import React from "react";
import StrokeIcon from "./StrokeIcon";

/** Work Orders: a clipboard with a check. Was the RFQ icon until 2026-10-01. */
export default function WorkOrdersIcon(props?: any) {
  return (
    <StrokeIcon iconProps={props}>
      {() => (
        <>
          <rect x="3" y="2.6" width="12" height="14" rx="1.4" />
          <rect x="6.4" y="1.2" width="5.2" height="2.6" rx="0.8" />
          <path d="M6 10l2 2 4-4.2" />
        </>
      )}
    </StrokeIcon>
  );
}
